import { useApi } from 'app/context';
import { useBasePaginatedList } from './useBasePaginatedList';
import { ICompanySchema } from 'generated/axios';
import { useCallback, useEffect } from 'react';

export const useCompanyList = () => {
  const { companyApi } = useApi();

  const {
    list,
    page,
    pageSize,
    handlePageChange,
    handlePageSizeChange,
    count,
    loading,
    setLoading,
    filter,
    handleFilter,
    handleError,
    handleSuccess,
  } = useBasePaginatedList<ICompanySchema>();

  const get = useCallback(() => {
    setLoading(true);
    companyApi
      .webPaginateCompanies(page, pageSize, filter)
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        handleSuccess(resp.data.results, resp.data.total);
      })
      .catch((err) => {
        handleError(err);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyApi, page, pageSize, filter]);

  const refresh = () => get();

  useEffect(() => {
    get();
  }, [get]);

  return {
    list,
    page,
    handlePageChange,
    pageSize,
    handlePageSizeChange,
    count,
    loading,
    setLoading,
    handleFilter,
    refresh,
  };
};
